import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import '@/assets/print.scss';

Vue.config.productionTip = false;

const existingUser = store.getters['auth/currentUser'];
if (existingUser) {
  Promise.all([
    store.dispatch('timetracking/init'),
    store.dispatch('projects/init'),
  ]);
}

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
